import Vue from 'vue'

import Loading from '@/components/loading/loading.vue'

export default Vue.extend({
  name: 'BookmarkEditActivator',

  props: {
    loading: {
      type: Boolean as Prop<boolean>
    }
  },

  components: {
    Loading
  },

  methods: {
    handleClick () {
      if (this.loading) {
        return
      }
      this.$emit('click')
    }
  }
})
